
export class ClearPredictiveFailureState{
  static readonly type = '[PREDICTIVE-FAILURe-Configuration] Clear selections'
}
export class GetAlgorithmList {
  static readonly type ='[PREDICTIVE-FAILURE-Configuration] Get Algorithm list'
  constructor(public configurationId: string){}
}

export class SetSelectedAlgorithm {
  static readonly type ='[PREDICTIVE-FAILURE-Configuration] Set selected algorithm'
  constructor(public algorithm: any){}
}

export class GetAlgorithmAssetList {
  static readonly type ='[PREDICTIVE-FAILURE-Configuration] Get Algorithm Asset list'
  constructor(public selectedAlgorithm: any, public refreshList?: boolean){}
}

export class SetSelectedAssetList {
  static readonly type ='[PREDICTIVE-FAILURE-Configuration] Set selected Asset List'
  constructor(public selectedAssets: any){}
}

export class RemoveSelectedAsset {
  static readonly type = '[PREDICTIVE-FAILURE-Configuration] Removed Selected Asset'
  constructor(public selectedAsset: any){}
}

export class SetSelectedConfiguration {
  static readonly type = '[PREDICTIVE-FAILURE-Configuration] Set selected Configuration'
  constructor(public configuration: any){}
}

export class GetKpiList {
  static readonly type = '[PREDICTIVE-FAILURE-Configuration] Get KPI List'
  constructor(public plantId: string) {}
}

export class SetSelectedImpactedKPIs {
  static readonly type = '[PREDICTIVE-FAILURE-Configuration] Set impacted KPIs'
  constructor(public impactedKPIs: any) {}
}

export class RemoveSelectedImpactedKPI {
  static readonly type = '[PREDICTIVE-FAILURE-Configuration] Removed Selected Impacted Kpi'
  constructor(public impactedKPI: any){}
}

export class SubmitPredictiveFailureConfiguration {
  static readonly type = '[PREDICTIVE-FAILURE-Configuration] Submit Predictive Failure Configuration'
}

export class GetDepartments {
  static readonly type = "[PREDICTIVE-FAILURE-Configuration] Get departments";
}

export class GetRoleIds {
  static readonly type = "[PREDICTIVE-FAILURE-Configuration] Get Role IDs by plant";
}
export class GetRolesByPlant {
  static readonly type = "[PREDICTIVE-FAILURE-Configuration] Get Roles by plant";
  constructor(public roleIdList: any[]) {}
}

export class GetRolesByDepartment {
  static readonly type = "[PREDICTIVE-FAILURE-Configuration] Get Roles";
  constructor(public departmentId: string) {}
}

export class GetThemes {
  static readonly type = "[PREDICTIVE-FAILURE-Configuration] Get themes";
  constructor(public configurationId: string) {}
}

export class GetSubTypes {
  static readonly type = "[PREDICTIVE-FAILURE-Configuration] Get Sub types";
  constructor(public themeId: string, public configurationId: string) {}
}

export class MoveStep {
  static readonly type ='[PREDICTIVE-FAILURE-Configuration] Next Step'
  constructor(public moveToStepIndex: number) {}
}

export class UpdateStepValidity {
  static readonly type ='[PREDICTIVE-FAILURE-Configuration] Update Step Validity'
  constructor(public stepIndex: number, public validity: boolean) {}
}

export class SetAssetsDuplicateDetected {
  static readonly type ='[PREDICTIVE-FAILURE-Configuration] Set Asset duplicated detected'
  constructor(public duplicate: boolean) {}
}

export class RemoveConfiguredAssets {
  static readonly type ='[PREDICTIVE-FAILURE-Configuration] Remove Asset Duplicates'
}


export class SetPredictiveFailureMode {
  static readonly type ='[PREDICTIVE-FAILURE-Configuration] Set Predictive failure mode'
  constructor(public mode: number) {}
}

export class GetPredictiveConfigurationDetails {
  static readonly type ='[PREDICTIVE-FAILURE-Configuration] Get Configuration details'
  constructor(public configId: string) {}
}

export class CheckConfigurationUpdated {
  static readonly type ='[PREDICTIVE-FAILURE-Configuration] Set Configuration Updated'
}

export class UpdateConfiguraitonDetails {
  static readonly type =`[PREDICTIVE-FAILURE-Configuration] Update Configuration Details`
}

export class SetAlgoLoading {
  static readonly  type = '[PREDICTIVE-FAILURE-Configuration] Set Algo Loading'
  constructor(public loading: boolean) {}
}

export class SetThresholdUomConfig {
  static readonly type = '[PREDICTIVE-FAILURE-Configuration] Set threshold config'
  constructor(public config: any) {}
}

export class GetTimeseries {
  static readonly type = "[PREDICTIVE-FAILURE-Configuration] Get timeseries";
}